import { Component } from '@angular/core';

import { Register } from '../../shared';


@Register({
  name: 'toolsContextManager',
  title: 'igo.contexts',
  icon: 'settings'
})
@Component({
  selector: 'igo-tools-context-manager-tool',
  template: require('./tools-context-manager-tool.component.html'),
  styles: [require('./tools-context-manager-tool.component.styl')]
})
export class ToolsContextManagerToolComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/tools-context-manager-tool/tools-context-manager-tool.component.ts